/* author:赵涛;
*  date:2020/12/14;
*  explan:采购相关接口结合；
*/
import api from "./api.js";
let baseURL4 = process.env.VUE_APP_zichan;
let baseURL5 = process.env.VUE_APP_Url_baseData;
let baseURL6 = process.env.VUE_APP_Url66;

// 采购页面接口
// 商品总列表
// export function shopList(params){return api.get_zt(`${baseURL4}api/Goods/list`,params)}//商品总列表
export function single(params){return api.get_zt(`${baseURL6}api/product/stock/list`,params)}//商品详情
// export function supplierList(params){return api.post_zt(`${baseURL4}api/Goods/SupplierList`,params)}//供应商列表

// 审批
export function shenpiList(params){return api.post_zt(`${baseURL4}api/ProcureRequest/list`,params)}//审批列表
// export function addcollection(params){return api.get_zt(`${baseURL4}api/ProcureRequest/addcollection`,params)}//增加收藏
// export function removecollection(params){return api.get_zt(`${baseURL4}api/ProcureRequest/removecollection`,params)}//取消收藏
export function getnocheckcount(params){return api.get_zt(`${baseURL4}/api/Procurement/getnocheckcount`,params)}//获取未审批数量

// 审批详情
// export function getDetail(params){return api.get_zt(`${baseURL4}api/ProcureRequest/get`,params)}//获取审批详情
export function shopConfirm(params){return api.get_zt(`${baseURL4}/api/Procurement/shopconfirm`,params)}//门店确认
export function addgoods(params){return api.post_zt(`${baseURL4}/api/Procurement/addgoods`,params)}//新增采购商品----
export function removegoods(params){return api.get_zt(`${baseURL4}/api/Procurement/removegoods`,params)}//删除商品
export function updategoods(params){return api.post_zt(`${baseURL4}/api/Procurement/updategoods`,params)}//修改商品数量
export function replacegoods(params){return api.post_zt(`${baseURL4}/api/Procurement/replacegoods`,params)}//替换商品
export function getCheck(params){return api.post_zt(`${baseURL4}/api/Procurement/check`,params)}//同意或者驳回
export function checkrejected(params){return api.get_zt(`${baseURL4}/api/Procurement/checkrejected`,params)}//撤销驳回
export function addbyrequest(params){return api.post_zt(`${baseURL4}/api/Procurement/addbyrequest`,params)}//根据采购申请单添加采购----
//采购单
export function previewByRequestAsync(params){return api.post_zt(`${baseURL4}/api/Procurement/PreviewByRequestAsync`,params)}//采购预览
export function caigouList(params){return api.post_zt(`${baseURL4}/api/Procurement/Procurelist`,params)}//获取采购申请单列表
export function addCaigou(params){return api.post_zt(`${baseURL4}/api/Procurement/addProcure`,params)}//新建采购单---
export function cancelCaigou(params){return api.get_zt(`${baseURL4}/api/Procurement/cancelProcure`,params)}//取消采购单
export function caigouDetail(params){return api.get_zt(`${baseURL4}/api/Procurement/GetProcureInfoResponse`,params)}//获取采购单
export function addProcureGoods(params){return api.post_zt(`${baseURL4}/api/Procurement/AddProcureGoods`,params)}//新增采购单商品
export function removeProcureGoods(params){return api.get_zt(`${baseURL4}/api/Procurement/RemoveProcureGoods`,params)}//移除采购单商品
// // 批量修改供应商
export function moreSupplier(params){return api.post_zt(`${baseURL4}/api/Procurement/UpdateValidationMoreSupplier`,params)}//批量修改供应商
export function supplierList(params){return api.post_zt(`${baseURL5}/api/Supplier/list`,params)}//供应商列表
// 验货
export function updateValidation(params){return api.post_zt(`${baseURL4}/api/Procurement/UpdateValidation`,params)}//验货
export function returnVerifyn(params){return api.get_zt(`${baseURL4}/api/Procurement/ProcureGoodsReturnVerify`,params)}//撤销验货
export function procureGoodsDistribution(params){return api.post_zt(`${baseURL4}/api/Procurement/ProcureGoodsDistribution`,params)}//分拨数据
export function updateGoodsRemarks(params){return api.post_zt(`${baseURL4}/api/Procurement/UpdateGoodsRemarks`,params)}//修改备注

export function caigouSuccess(params){return api.get_zt(`${baseURL4}/api/Procurement/ProcureSuccess`,params)}//采购完成
export function outbound(params){return api.post_zt(`${baseURL4}/api/Procurement/Outbound`,params)}//分拨出库
export function upLoadDistribution(params){return api.get_zt(`${baseURL4}/api/Procurement/UpLoadDistribution`,params)}//下载分拨单